import {Task} from './TaskForm';

// Check if type has all required due fields
type HasRequiredDueFields = {
  dueDate: Task['dueDate'];
  dueFrom: Task['dueFrom'];
  dueTo: Task['dueTo'];
};

// If type contains all due fields, return Partial<Task>, otherwise return Task
export type TaskFormInput =
  Pick<Task, keyof HasRequiredDueFields> extends HasRequiredDueFields ? Partial<Task> : Task;
